import store from '@/store'
import {urls, getGoogleGeo} from '@/services'
import local from '@/localStorage'

const defaultCoords = {
  lat: -31.25260,
  lon: -61.49164,
  city: 'Rafaela'
}

const defaultDistance = -1

const defaultDistances = [
  { city: 'Rafaela', distance: -1 }
]

const isMobile = () => {
  let check = false;
  (a => {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))
      check = true
  }) (navigator.userAgent || navigator.vendor || window.opera)
  return check
}

/**
 * Save location to localStorage.
 *
 * @uses localStorage
 * @param {object[float,float]} latitude and longitude as floats
 * @return {boolean} whether success or not
 */
export function saveLocationLocalStorage ({latitude, longitude}) {
  console.log('saveLocationLocalStorage')
  if (!window.localStorage) {
    console.log('LocalStorage not supported')
    return false
  }

  localStorage.setItem('latitude', latitude)
  localStorage.setItem('longitude', longitude)

  return true
}

/**
 * Load location from localStorage to state.
 *
 * @uses dispatch setLocation
 * @return {boolean} whether success or not.
 */
function getFromLocalStorage () {
  console.log('getFromLocalStorage')
  // check localStorage capabilites
  if (!window.localStorage) {
    console.warn('LocalStorage not supported')
    return false
  }

  const latitude = parseFloat(localStorage.getItem('latitude'))
  const longitude = parseFloat(localStorage.getItem('longitude'))

  if (latitude && longitude) {
    return store.dispatch('setLocation', { coords: {latitude, longitude} })
  }

  return false
}

/**
 * Attempts to fetch location from API.
 *
 * @return {Promise[object]} coords.
 */
async function getLocationAPI () {
  console.info('getLocationAPI')

  return fetch(urls.geolocation)
    .then(res => res.json())
    .then(data => ({ data }))
    .then(({data}) => {
      // ipapi.co returns: latitude, longitude, city, country_name
      const coords = data && ({
        lat: parseFloat(data.latitude).toFixed(5),
        lon: parseFloat(data.longitude).toFixed(5),
        city: `${data.city}, ${data.country_name}`
      })

      // check if the parsed data is ok
      if (!data.latitude
        || !data.longitude
        || isNaN(parseFloat(coords.lat))
        || isNaN(parseFloat(coords.lon))
        || coords.city.length <= 2
        ) {
        store.dispatch('setDistance', mapDefaultDistance(defaultCoords.city))
        store.dispatch('setLocation', {coords: defaultCoords})
      } else {
        local.setLocation(coords)
        const currentCity = store.state.currentCity
        // If currentCity is already set, do not replace it
        if (currentCity) coords.city = currentCity
        store.dispatch('setLocation', {coords, sync: false})
      }

    })
    .catch(err => {
      console.warn('getLocationAPI - not allowed?', err)
      // Set default location to Rafaela
      store.dispatch('setDistance', mapDefaultDistance(defaultCoords.city))
      store.dispatch('setLocation', {coords: defaultCoords})
    })
}

export const fetchCity = ({lat, lon}) => getGoogleGeo({lat, lon})
  .then(({data}) => ({
    lat: lat,
    lon: lon,
    city: parseGoogleLocality(data)
  }))
  .catch(err => {
    console.warn('Google loc:', err)
    return {lat, lon}
  })

const parseGoogleLocality = ({results}) => {
  if (results) {
    const localityResult = results.find(a => a.types.includes('locality'))
    const localityAddr = localityResult && localityResult.address_components.find(c => c.types.includes('locality'))
    const plusCodeResult = results.find(a => a.types.includes('plus_code'))
    const plusCodeAddr = plusCodeResult && plusCodeResult.address_components.find(c => c.types.includes('locality'))
    const routeResult = results.find(a => a.types.includes('route'))
    const routeAddr = routeResult && routeResult.address_components.find(c => c.types.includes('locality'))
    const streetAddressResult = results.find(a => a.types.includes('street_address'))
    const streetAddr = streetAddressResult && streetAddressResult.address_components.find(c => c.types.includes('locality'))
    return localityAddr && localityAddr.short_name || plusCodeAddr && plusCodeAddr.short_name ||
      routeAddr && routeAddr.short_name || streetAddr && streetAddr.short_name
  } else {
    return null
  }
}

export const fetchCityProvince = ({lat, lon}) => getGoogleGeo({lat, lon})
  .then(({data}) => {
    let locality = parseGoogleLocality(data)
    locality = locality ? locality.replace('Ciudad de ', '') : locality
    let province = parseGoogleProvince(data)
    province = province ? province.replace('Provincia de ', '') : province
    const city = locality + ', ' + province

    return {
      lat: lat,
      lon: lon,
      city
    }
  })
  .catch(err => {
    console.warn('Google loc:', err)
    return {lat, lon}
  })

const parseGoogleProvince = ({results}) => {
  if (results) {
    const provinceResult = results.find(a => a.types.includes('administrative_area_level_1'))
    const province = provinceResult && provinceResult.address_components.find(c => c.types.includes('administrative_area_level_1'))
    return province && province.short_name
  } else {
    return null
  }
}

const filterLocation = location => {
  if (location && location.startsWith('Ciudad de ')) {
    location = location.replace('Ciudad de ', '')
  }
  if (location && location.endsWith('Argentina')) {
    const stringArray = location.split(',')
    stringArray.splice(stringArray.length - 1, 1)
    return stringArray.join(',') || location
  } else {
    return location
  }
}

export const mapDefaultDistance = city => {
  const matchingCity = defaultDistances.filter(d => city.includes(d.city))
  return matchingCity.length > 0 && matchingCity[0].distance || defaultDistance
}

export const asyncDetect = () => {
  // Geolocation from browser
  if (navigator.geolocation) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(pos => resolve({
        lat: pos.coords.latitude,
        lon: pos.coords.longitude
      }), err => reject(err))
    })
      // gets city from googlegeo
      .then(fetchCity)
  } else {
    console.warn("Your browser doesn't allow geolocation")
  }
}

async function init () {
  let coords = local.getLocation()
  // Geolocation from localStorage
  if (coords) {
    store.dispatch('setLocation', {coords, sync: false})
  } else {
    // If user is logged, location is set to localstorage on any call to action store('user/fetchUserInfo')
    // If user is not logged and location is not in localstorage, try to get it with getLocationAPI()
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    const connectionType = connection && connection.type
    const mobile = isMobile()

    if (!mobile || mobile && connectionType === 'wifi') {
      await getLocationAPI()
    } else {
      // Default location to rafaela
      store.dispatch('setDistance', mapDefaultDistance(defaultCoords.city))
      store.dispatch('setLocation', {coords: defaultCoords})
    }
  }
}

export default {
  getFromLocalStorage,
  getLocationAPI,
  init
}



// WEBPACK FOOTER //
// ./src/location.js